export const QA_NAME_SEARCH_RESULTS_PROVIDERS_TABLE =
  'searchResultsProvidersTable'

export const SEARCH_RESULTS_PROVIDERS_CONFIG_API =
  'idwell-api/api/v3/table/tables/contractors-search/'

export const SEARCH_RESULTS_PROVIDERS_LIST_API =
  'idwell-api/api/v3/contractor/contractors/search/'
